import type { UserProfile } from './types'

export function hasUnrestrictedStatusAccess(profile: UserProfile) {
  return profile === 'Administrador'
}
